// extracted by mini-css-extract-plugin
module.exports = {"popoverMessage":"partial-annotation_popoverMessage__1jn9A"};